"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.accessibility");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.metrics");

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.common");

var _gerenciatdUtils4 = require("@bit/gerenciatd.utils.tagging");

var _gerenciatdUtils5 = require("@bit/gerenciatd.utils.log-utils");

require("./CustomLink.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const ANALYTICS_PARAMS = {
  posCode: 'prevPosCode',
  phCode: 'prevPhCode',
  webCode: 'prevWebCode'
};
const COMPONENT_NAME = 'CustomLink';

const addParamsToLink = (link, taggingInfo) => {
  if (link.indexOf('tel:') === 0) {
    return link;
  }

  let result = link;
  let separator = link.indexOf('?') < 0 ? '?' : '&';
  Object.keys(ANALYTICS_PARAMS).forEach(key => {
    if (taggingInfo && taggingInfo.componentPerso && taggingInfo.componentPerso[key]) {
      result += `${separator}${ANALYTICS_PARAMS[key]}=${taggingInfo.componentPerso[key]}`;
      separator = '&';
    }
  });
  return result;
};

const isExternalLink = (link = '') => {
  let external = false;

  if (link && (link.indexOf('movistar.es') > -1 || link.indexOf('col10mgmt.tsm.inet') > -1 || link.indexOf('http:') > -1 || link.indexOf('https:') > -1 || link.indexOf('www.') > -1 || link.indexOf('data:application/') > -1)) {
    external = true;
  }

  return external;
};

const normalizeExternalLink = link => {
  let normalizedLink = link;

  if (link.startsWith('www.')) {
    normalizedLink = `http://${link}`;
  }

  return normalizedLink;
};

const CustomLink = ({
  id,
  onClick,
  link,
  taggingInfo,
  buttonType,
  text,
  accInfo,
  className,
  target,
  isBlockElement,
  children,
  forceExternal,
  download,
  disable
}) => {
  // checking id
  let finalDOMId = id;

  if (!finalDOMId) {
    finalDOMId = `CustomLink-${(0, _gerenciatdUtils3.giveRandomNumber)(1, 999)}`;
  } //


  let insideInfo = '';
  const production = process.env.NODE_ENV === 'production';
  let isValid = true;

  const childrenArray = _react.default.Children.toArray(children);

  if (childrenArray.length !== 0) {
    if (!production) {
      childrenArray.forEach(element => {
        if (element && element.type && element.type.name) {
          if (!(0, _gerenciatdUtils.isAnchorAllowedChild)(element.type.name)) {
            isValid = false;
          }
        } else if (element && element.type) {
          if (!(0, _gerenciatdUtils.isAnchorAllowedChild)(element.type)) {
            isValid = false;
          }
        }
      });
    }

    if (isValid) {
      insideInfo = children;
    } else {
      (0, _gerenciatdUtils5.errorLog)('[CustomLink]: children must be inline elements', '[CustomLink]: inlinechildren');
      return null;
    }
  } else {
    insideInfo = text;
  }
  /* Checkings */


  if (isBlockElement) {
    (0, _gerenciatdUtils5.warnLog)('[CustomLink]: Make sure that my parent node has position relative', 'CustomLink-isBlockElement');
  }

  if (!onClick && !link && buttonType !== 'submit') {
    (0, _gerenciatdUtils5.errorLog)('[CustomLink]: Doesnt make sense that CustomLink has not link neither onClick', 'CustomLink-hasLink|onClick');
    return null;
  }

  const externalLink = isExternalLink(link) || forceExternal;

  if (target && target !== '_self') {
    (0, _gerenciatdUtils5.warnLog)('[CustomLink]: Becareful working with target prop', 'CustomLink-target');
  }

  if (!taggingInfo) {
    (0, _gerenciatdUtils5.errorLog)('[CustomLink]: taggingInfo is not present', '[CustomLink]:taggingInfo');
    return null;
  }

  const taggingWellFormed = (0, _gerenciatdUtils2.checkEventObj)(taggingInfo);

  if (!taggingWellFormed) {
    (0, _gerenciatdUtils5.errorLog)('[CustomLink]: taggingInfo does not satisfy conditions', '[CustomLink]:taggingInfo shape');
    return null;
  }
  /* CHEEKING ENDS */

  /* Desencapsulating accesibilityInfo */


  const {
    hideAccesible,
    title,
    ariaLabel,
    screenReadable
  } = accInfo;
  const isHideAccesibilityCss = hideAccesible ? ' hideacc' : '';
  const classNameCss = className ? ` ${className}` : '';
  const isBlockCss = isBlockElement ? ' linkoverbox' : '';
  /* Handling OnClick */

  const handleClick = () => {
    if (!disable) {
      const taggingInfoCompleted = _objectSpread({
        eventType: 'click'
      }, taggingInfo);

      if (!taggingInfoCompleted.componentName) {
        taggingInfoCompleted.componentName = COMPONENT_NAME;
      }

      if (!taggingInfoCompleted.componentContent) {
        taggingInfoCompleted.componentContent = _gerenciatdUtils4.CUSTOM_LINK_CONTENT.DEFAULT;
      }

      (0, _gerenciatdUtils2.sendCMSEvent)(taggingInfoCompleted);

      if (onClick) {
        onClick();
        return true;
      }
    }

    return false;
  };
  /* Handling onKeyDown */


  const handleOnKeyDown = event => {
    const e = event || evt; // for trans-browser compatibility

    const charCode = e.which || e.keyCode;

    if (charCode && charCode === 13) {
      handleClick();
    }

    return false;
  };

  const handleMouseDown = event => {
    const taggingInfoCompleted = _objectSpread({
      eventType: 'click'
    }, taggingInfo);

    const e = event || evt;

    if (e.button === 1) {
      (0, _gerenciatdUtils2.sendCMSEvent)(taggingInfoCompleted);
      handleClick();
    }
  };
  /* LINK */


  if (link) {
    const href = !disable ? addParamsToLink(link, taggingInfo) : '#'; // EXTERNAL

    if (externalLink) {
      const normalizedExternalLink = normalizeExternalLink(href);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        id: finalDOMId,
        "aria-label": ariaLabel,
        "aria-hidden": !screenReadable,
        title: title,
        className: `CustomLink${isBlockCss}${isHideAccesibilityCss}${classNameCss}`,
        href: normalizedExternalLink,
        target: target,
        rel: "noopener noreferrer",
        tabIndex: "0",
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyDown: handleOnKeyDown,
        download: download || false,
        children: insideInfo
      });
    } // INTERNAL


    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
      id: finalDOMId,
      className: `CustomLink${isBlockCss}${isHideAccesibilityCss}${classNameCss}`,
      to: href,
      onClick: handleClick,
      onMouseDown: handleMouseDown,
      onKeyDown: handleOnKeyDown,
      children: insideInfo
    });
  }
  /* NO LINK so it should have onClick */


  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    id: finalDOMId,
    type: buttonType,
    "aria-label": ariaLabel,
    "aria-hidden": !screenReadable,
    title: title,
    className: `CustomLink${isBlockCss}${isHideAccesibilityCss}${classNameCss}`,
    tabIndex: "0",
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    onKeyDown: handleOnKeyDown,
    children: insideInfo
  });
};

CustomLink.propTypes = {
  /**
   * {
   *  "info": "Establece un id para el elemento DOM",
   *  "kind": "playground",
   *  "beautifulName": "id"
   * }
   */
  id: _propTypes.default.string,

  /**
   * {
   *  "info": "Url asociada al componente",
   *  "kind": "both",
   *  "beautifulName": "Enlace"
   * }
   */
  link: _propTypes.default.string,

  /**
   * {
   *  "info": "Texto que aparecerá dentro del componente",
   *  "kind": "both",
   *  "beautifulName": "Texto"
   * }
   */
  text: _propTypes.default.string,

  /**
   * {
   *  "info": "Función js que se ejecutará al hacer click, si es necesario",
   *  "kind": "both",
   *  "beautifulName": "Funcion"
   * }
   */
  onClick: _propTypes.default.func,

  /**
   * {
   *  "info": "Define la información para la accesibilidad del componente como: title, ariaLabel, screenReadable, hideAccesible",
   *  "kind": "playground",
   *  "beautifulName": "Accesibilidad"
   * }
   */
  accInfo: _propTypes.default.object,

  /**
   * {
   *  "info": "Establece si el elemento debe comportarse como un bloque o no",
   *  "kind": "both",
   *  "beautifulName": "Elemento bloque"
   * }
   */
  isBlockElement: _propTypes.default.bool,

  /**
   * {
   *  "info": "Establece el nombre al fichero recibido como link en caso de que se vaya a descargar",
   *  "kind": "both",
   *  "beautifulName": "Descargar"
   * }
   */
  download: _propTypes.default.string,

  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes.default.object.isRequired,

  /**
   * {
   *  "info": "Define si el enlace se tiene que forzar a comportar como enlace externo",
   *  "kind": "both",
   *  "beautifulName": "Enlace externo"
   * }
   */
  forceExternal: _propTypes.default.bool,

  /**
   * {
   *  "info": "Define donde tiene tiene que abrirse el enlace asociado al componente",
   *  "kind": "both",
   *  "beautifulName": "Target"
   * }
   */
  target: _propTypes.default.oneOf(['_self', '_blank', 'parent', '_top']),

  /**
   * {
   *  "info": "Define el tipo de boton que renderiza el customLink",
   *  "kind": "both",
   *  "beautifulName": "Target"
   * }
   */
  buttonType: _propTypes.default.oneOf(['button', 'submit', 'reset']),

  /**
   * {
   *  "info": "Define si el boton esta inactiva",
   *  "kind": "both",
   *  "beautifulName": "Target"
   * }
   */
  disable: _propTypes.default.bool
};
CustomLink.defaultProps = {
  id: '',
  onClick: null,
  link: null,
  text: '',
  accInfo: {
    title: '',
    ariaLabel: '',
    // its apply aria-hidden
    screenReadable: true,
    // true => !aria-hidden
    hideAccesible: false // className=hideaccesibility

  },
  isBlockElement: false,
  download: '',
  forceExternal: false,
  target: '_self',
  buttonType: 'button',
  disable: false
};
var _default = CustomLink;
exports.default = _default;

//# sourceMappingURL=index.js.map